import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-border">
      <div className="mx-auto max-w-[1280px] px-6 md:px-8 lg:px-12 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="inline-flex items-center mb-5" aria-label="Hauptstadt Consulting Partners, Startseite">
              <Logo />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-[320px]">
              Berlins stärkste Finanzberatung entsteht gerade und wir suchen Menschen die von Anfang an dabei sein wollen.
            </p>
          </div>

          <div>
            <h4 className="text-foreground font-semibold text-sm mb-4">Kontakt</h4>
            <ul className="space-y-2.5 text-sm">
              <li className="text-muted-foreground">Hauptstadt Consulting Partners</li>
              <li className="text-muted-foreground">c/o Horbach Wirtschaftsberatung</li>
              <li className="text-muted-foreground">Meierottostr. 7, 10719 Berlin</li>
              <li>
                <a href="mailto:klemens.von-rosen@horbach.de" className="text-muted-foreground hover:text-foreground transition-colors">
                  klemens.von-rosen@horbach.de
                </a>
              </li>
              <li>
                <a href="tel:+4915901981213" className="text-muted-foreground hover:text-foreground transition-colors">
                  +49 (1590) 1981213
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground font-semibold text-sm mb-4">Karriere</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/karriere" className="text-muted-foreground hover:text-foreground transition-colors">Karriere im Detail</Link></li>
              <li><Link to="/#warum" className="text-muted-foreground hover:text-foreground transition-colors">Warum HCP</Link></li>
              <li><Link to="/#faq" className="text-muted-foreground hover:text-foreground transition-colors">FAQ</Link></li>
              <li><Link to="/bewerben" className="text-primary-dark hover:underline font-medium">Jetzt bewerben</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto max-w-[1280px] px-6 md:px-8 lg:px-12 py-5 max-md:pb-24 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground text-xs">
            © {currentYear} Hauptstadt Consulting Partners. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/datenschutz" className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2">Datenschutz</Link>
            <Link to="/impressum" className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2">Impressum</Link>
            <button
              onClick={() => { localStorage.removeItem('cookie-consent'); window.location.reload(); }}
              className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
